import styled from "styled-components/macro";
import {
  MOBILE_PERCENT_BAR_HEIGHT_PX,
  PERCENT_BAR_HEIGHT_PX,
} from "./PercentBar";
import {
  FONT_SIZE_EXTRA_SMALL,
  BREAKPOINT_TABLET,
  BREAKPOINT_MOBILE,
  BREAKPOINT_TABTOP,
} from "../../../../constants/constants";

type PnLChartStylesType = {
  $maxCategoryOrTagNameLength: number;
  $numColumns: number;
};

const numColumnsGridCSS = ({
  $maxCategoryOrTagNameLength,
  $numColumns,
}: PnLChartStylesType) => {
  const categoryOrTagWidth =
    $maxCategoryOrTagNameLength >= 30 ? "3fr" : "2.5fr";
  return `${categoryOrTagWidth} repeat(${$numColumns}, 1fr) 2.5fr`;
};

const numColumnsGridCSSMobile = ({
  $maxCategoryOrTagNameLength,
  $numColumns,
}: PnLChartStylesType) => {
  const categoryOrTagWidth =
    $maxCategoryOrTagNameLength >= 30 ? "2.5fr" : "1.5fr";
  return $numColumns > 2
    ? `${categoryOrTagWidth} repeat(${$numColumns}, 1fr) 1fr`
    : `${categoryOrTagWidth} repeat(${$numColumns}, 1fr) 1.5fr`;
};

export const PnLChartStyles = styled.div<PnLChartStylesType>`
  margin: 0em auto;
  padding: 1em 0;
  width: ${props => (props.$numColumns > 3 ? "60%" : "50%")};
  font-size: 18px;

  .row {
    display: grid;
    align-items: center;
    grid-template-columns: ${props => numColumnsGridCSS({ ...props })};
  }

  .pnlCategory,
  .subTagRow {
    margin-bottom: ${PERCENT_BAR_HEIGHT_PX / 3}px;
  }

  .pnlCategory {
    .title,
    .percent,
    .time,
    .lostOutput,
    .nbEvents,
    .avgDuration {
      font-weight: bold;
    }
  }

  .circle {
    border: 1px solid black;
    width: ${PERCENT_BAR_HEIGHT_PX}px;
    height: ${PERCENT_BAR_HEIGHT_PX}px;
    border-radius: 50%;
    display: inline-block;
  }

  .title {
    display: flex;
    align-items: center;
  }

  .circleDiv {
    display: flex;
    align-self: center;
    padding-right: 5px;
  }

  .subTag {
    margin-top: ${PERCENT_BAR_HEIGHT_PX / 3}px;
  }

  .subTagRow {
    font-weight: normal;
  }

  .subTagRow > .title {
    margin-left: 1.5em;
  }

  .percent,
  .time,
  .nbEvents,
  .avgDuration,
  .lostOutput {
    text-align: center;
  }

  .percent-value {
    font-weight: normal;
    text-align: center;
  }

  .bar {
    width: 100%;
    text-align: center;
  }

  @media (max-width: ${BREAKPOINT_TABTOP}px), print {
    width: 90%;
  }

  @media (max-width: ${BREAKPOINT_TABLET}px), print {
    width: 90%;
    font-size: ${FONT_SIZE_EXTRA_SMALL}px;

    .row {
      grid-template-columns: ${props => numColumnsGridCSSMobile({ ...props })};
    }

    .circle {
      width: 10px;
      height: 10px;
    }

    .subTag {
      margin-top: ${MOBILE_PERCENT_BAR_HEIGHT_PX / 4}px;
    }

    .subTagRow > .title {
      margin-left: ${MOBILE_PERCENT_BAR_HEIGHT_PX / 4}px;
    }

    .pnlCategory,
    .subTagRow {
      margin-bottom: ${MOBILE_PERCENT_BAR_HEIGHT_PX / 4}px;
    }

    .time-data {
      grid-template-columns: 1fr 1fr;
    }

    .title,
    .percent,
    .time,
    .nbEvents,
    .avgDuration {
      font-size: ${FONT_SIZE_EXTRA_SMALL + 2}px;
    }
  }

  @media (max-width: ${BREAKPOINT_MOBILE}px), print {
    font-size: ${FONT_SIZE_EXTRA_SMALL}px;

    .title,
    .percent,
    .time,
    .nbEvents,
    .avgDuration {
      font-size: ${FONT_SIZE_EXTRA_SMALL}px;
    }
  }
`;
